import { useEffect, useState, useCallback, createContext, useContext, useMemo } from 'react';
import Notification, { NotificationPropType } from '../Notification/Notification/Notification';
import { useToast } from '../Toast/ToastProvider';
import { Theme } from '../types/enums';
import { Props } from './types/propTypes';

const AdminToastContext = createContext<{
  adminToast: (props: NotificationPropType) => void;
}>({
  adminToast: () => null,
});

export const AdminToast = ({ children, timeout, topPosition }: Props) => {
  const { addToast, deleteToast } = useToast();
  const [notificationProps, setNotificationProps] = useState<NotificationPropType>({
    message: '',
    theme: Theme.BLACK,
    description: '',
    textLink: undefined,
    hasBoldText: true,
    hasNotificationIcon: true,
  });

  const adminToast = useCallback(
    (props: NotificationPropType) => {
      const newNotification: NotificationPropType = {
        ...notificationProps,
        ...props,
      };
      setNotificationProps(newNotification);
    },
    [notificationProps, setNotificationProps],
  );

  const contextValue = useMemo(() => ({ adminToast }), [adminToast]);

  useEffect(() => {
    if (notificationProps.message) {
      const { message } = notificationProps;
      addToast({
        id: message,
        content: <Notification {...notificationProps} onCloseClick={() => deleteToast(message)} />,
        timeout: timeout,
        topPosition: topPosition,
      });
    }
  }, [notificationProps, addToast, deleteToast]);

  return <AdminToastContext.Provider value={contextValue}>{children}</AdminToastContext.Provider>;
};

const useAdminToast = () => {
  const { adminToast } = useContext<{
    adminToast: (props: NotificationPropType) => void;
  }>(AdminToastContext);
  return { adminToast };
};

export { useAdminToast };
export default AdminToast;
